import { TradeSubTradeItem } from 'app/models/trade-sub-trade-params'
import { TradeSubTradesState } from './reducer'

const EMPTY: TradeSubTradeItem[] = []

export const getTradeSubTrades = (masterTradeId: string) => (state: { tradeSubTrades: TradeSubTradesState }) =>
  state.tradeSubTrades.byMasterTrade[masterTradeId] ?? EMPTY

/** True once the trade's read has landed at least once (an empty list counts). */
export const hasTradeSubTradesLoaded = (masterTradeId: string) => (state: { tradeSubTrades: TradeSubTradesState }) =>
  masterTradeId in state.tradeSubTrades.byMasterTrade

export const isTradeSubTradesLoading = (masterTradeId: string) => (state: { tradeSubTrades: TradeSubTradesState }) =>
  Boolean(state.tradeSubTrades.loadingByMasterTrade[masterTradeId])

/** True when the trade's last read failed and no read is in flight since. */
export const hasTradeSubTradesFailed = (masterTradeId: string) => (state: { tradeSubTrades: TradeSubTradesState }) =>
  Boolean(state.tradeSubTrades.failedByMasterTrade?.[masterTradeId])
